import {Form} from 'antd';
import React, {useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../../constants/Common';
import {APITypeEnum} from '../../../../../services/interface/tableAPIType';
import productsJSON from '../../../../../services/modules/JSON/products';
import rawMaterialJson from '../../../../../services/modules/JSON/rawMaterial';
import supplierInfo from '../../../../../services/modules/OM/supplierInfoDetails';
import productInfoAPI from '../../../../../services/modules/PRODUCTS/ProductInfoAPI';
import rawMaterialAPI from '../../../../../services/modules/PRODUCTS/rawMaterialAPI';
import useCompanyStore from '../../../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../../../store/StaticJson/jsonStore';
import {FacilityKey} from '../../../../Forms/Constants/IP/FacilityKeyLabel';
import {upstreamKey} from '../../../../Forms/Constants/IP/UpstreamKeyLabel';
import {excludeSacProducts} from '../../../../Forms/Constants/Products/ProductInfoKeyLabel';
import {RawMaterialKey} from '../../../../Forms/Constants/Products/RawMaterialKeyAndLabel';
import RawAverageForm from '../../../../Forms/RawAverageForm';
import Loader from '../../../../Loader/Loader';
import {returnProductFilter} from '../../../../Table/Utils/returnProductFilters';
import {IComponentProps} from '../../../Common/perquisiteMaster';

const RawMaterialSupplierBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const initialValues = {
    year: record?.year
  };
  const [formRawMaterialFilter, setFormRawMaterialFilter] = useState<any>({});
  const [suppliers, setSuppliers] = useState([]);
  const [editData, setEditData] = useState<any>(undefined);

  useEffect(() => {
    Promise.all([
      record?.referenceRecordId &&
        rawMaterialAPI(
          APITypeEnum.GET_ONE,
          {},
          `RawMaterialById/${record?.referenceRecordId}`
        ),
      productInfoAPI(
        APITypeEnum.GET_ALL,
        undefined,
        `${record?.company}/${record?.year}`
      ),
      supplierInfo(
        APITypeEnum.GET_ALL,
        'company',
        `${record?.company}/${record?.year}/upstream`
      ),
      productsJSON(),
      rawMaterialJson()
    ])
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(([res1, productRes, supplierRes]) => {
        const state = useCompanyStore.getState();
        const facilityOptions =
          state.facilityDetails?.[record?.year ?? '']
            ?.map((item: any) =>
              item._id === record?.facility
                ? {value: item._id, label: item?.[FacilityKey.FACILITY_NAME]}
                : null
            )
            .filter(Boolean) ?? [];

        const {products, rawMaterials} = useJSONStore.getState();

        setFormRawMaterialFilter(
          returnProductFilter(
            [
              {
                mainKey: RawMaterialKey.PRODUCT_ID,
                filterer: excludeSacProducts(products),
                subKey: '',
                returnFilterKey: 'productFilter'
              },
              {
                mainKey: RawMaterialKey.FACILITY_MAIN,
                filterer: facilityOptions,
                subKey: RawMaterialKey.FACILITY_ID,
                returnFilterKey: 'facilityFilter'
              },
              {
                mainKey: RawMaterialKey.RAW_MATERIAL_MAIN,
                filterer: rawMaterials,
                subKey: RawMaterialKey.RAW_MATERIAL_ID,
                returnFilterKey: 'rawFilter'
              }
            ],
            productRes
          )
        );
        setSuppliers(
          supplierRes.map((item: any) => {
            return {
              label: item?.[upstreamKey.SUPPLIER_NAME],
              value: item._id,
              data: item?.data
            };
          }) ?? []
        );

        if (res1?.data?.isDeleted === false) {
          caForm.setFieldsValue(res1?.data);
          setEditData(res1?.data);
          onValuesChange(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <RawAverageForm
        data={editData}
        setSubmitDisabled={() => {}}
        isAverage={false}
        rawMaterialFilter={formRawMaterialFilter}
        suppliers={suppliers}
        setFormSelectedYear={() => {}}
        setIsFormLoading={() => {}}
        isFormLoading={false}
        defaultDisplayStep={true}
      />
      <Form.Item
        name={'company'}
        hidden={true}
        initialValue={record?.company}
      />
    </Form>
  );
};

export default RawMaterialSupplierBills;
